import Vue from 'vue'
import './hooks' // This must be imported before any component
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'
import fr from 'vuetify/src/locale/fr'
// Libraries imports
import { locale } from 'moment'
import Vuetify from './plugins/vuetify'

// App imports
import registerGlobalFilters from '@/helper/register-global-filters'

registerGlobalFilters(Vue)

Vue.config.productionTip = false

// Libraries config
locale('fr')

new Vue({
  vuetify: Vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
